import { Model as e } from "../../../../../model.js";
class m extends e {
}
export {
  m as StampProgrammeApplicationRuleModel
};
//# sourceMappingURL=stampProgrammeApplicationRule.model.js.map
